var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 170,
    viewBox: "0 0 169 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 37H57.8333V58.3333H36.5V37Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 111.667H57.8333V133H36.5V111.667Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.167 37H132.5V58.3333H111.167V37Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 90.3333H79.1667V101",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 101V133H132.5V101H121.833",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1669 122.333V133",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.167 37V69H89.8337",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.167 79.6666H132.5",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 42.3333V15.6667C4.5 9.77563 9.27563 5 15.1667 5H41.8333",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.167 5H153.834C159.725 5 164.5 9.77563 164.5 15.6667V42.3333",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 127.667V154.333C164.5 160.224 159.725 165 153.834 165H127.167",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 165H15.1667C9.27563 165 4.5 160.224 4.5 154.333V127.667",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 8.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrCode);
export default __webpack_public_path__ + "static/media/Icon_qr_code.8585e8fe.svg";
export { ForwardRef as ReactComponent };